import dayjs from 'dayjs';

function readableId({ created }) {
    const date = dayjs(created).utc();
    if (created > 1734773313460) {
        return `${date.year() - 2000}${date.month() + 1}${date.date()}${parseInt(created / 1000) % (60 * 60 * 24)}`;
    } else {
        // Backwards compatibility for a bug
        return `${date.year() - 2000}${date.month() + 1}${date.date()}${parseInt(created / 1000) % 60 * 60 * 24}`;
    }
}

export default readableId;
